import React, { useEffect, useState } from 'react';
import { useUser, useClerk } from '@clerk/clerk-react';
import { useNavigate, useLocation } from 'react-router-dom';
import OnboardingModal from '../components/onboarding/OnboardingModal';
import { handleLogout } from '../lib/logout';

interface OnboardingPageProps {
  showPendingRequest?: boolean;
}

export default function OnboardingPage({ showPendingRequest = false }: OnboardingPageProps) {
  const { user, isLoaded } = useUser();
  const { signOut } = useClerk();
  const navigate = useNavigate();
  const location = useLocation();
  const [showOnboarding, setShowOnboarding] = useState(true);

    console.log('🎯 ONBOARDING PAGE RENDERED:', {
    isLoaded,
    hasUser: !!user,
    userId: user?.id
  });
  

  useEffect(() => {
    console.log('🎯 ONBOARDING PAGE useEffect:', { isLoaded, hasUser: !!user, userId: user?.id });
    
    
    // If user is not loaded yet, wait
    if (!isLoaded) {
      console.log('🎯 ONBOARDING PAGE: User not loaded, waiting...');
      return;
    }

    // If user is not signed in, redirect to home
    if (!user) {
      console.log('🎯 ONBOARDING PAGE: No user found, redirecting to home');
      
      
      navigate('/');
      return;
    }

    console.log('🎯 ONBOARDING PAGE: User found, showing onboarding');
    
    
    // TODO: Check if user already has an organization
    // For now, always show onboarding
  }, [user, isLoaded, navigate]);

  const handleOnboardingComplete = () => {
    setShowOnboarding(false);
    // Redirect to the appropriate page based on onboarding result
    // This will be handled by the app's routing logic after refresh
    navigate('/');
    window.location.reload(); // Refresh to update auth state
  };

  const handleOnboardingClose = async () => {
    // If user closes onboarding without completing, sign them out
    // This prevents them from accessing any protected content
    await handleLogout(signOut)();
  };

  if (!isLoaded) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user) {
    return null; // Will redirect via useEffect
  }

  return (
    <div className="min-h-screen bg-background">
      <OnboardingModal
        isOpen={showOnboarding}
        onClose={handleOnboardingClose}
        onComplete={handleOnboardingComplete}
        initialStep={showPendingRequest ? 'join_request_submitted' : 'choice'}
      />
    </div>
  );
}
